import React from "react";
import Notification from "@/components/Notification";
import BarHeader from "@/components/BarHeader";
import BarNavigation from "@/components/BarNavigation";
import BarNavigationPDV from "@/components/BarNavigationPDV";

import { Container } from "./styles";

const Layout = ({ children }) => {
	const type = localStorage.getItem("@type");

	return (
		<React.Fragment>
			<Notification />
			<BarHeader />
			<Container>
				<main className='layout'>{children}</main>
				{type === "consumer" && <BarNavigation />}
				{type === "merchant" && <BarNavigationPDV />}
			</Container>
		</React.Fragment>
	);
};

export default Layout;
